/** Subset of Zustand's `persist` API used to wait for rehydration from storage. */
export type ZustandPersistApi = {
  hasHydrated: () => boolean;
  onFinishHydration: (onHydrated: () => void) => () => void;
};

/**
 * Runs `onHydrated` once persisted state is in memory, or immediately when `persist` is missing
 * (e.g. Next static generation without `localStorage`).
 *
 * @returns An unsubscribe function when waiting on `onFinishHydration`; otherwise `undefined`.
 */
export const subscribeZustandPersistHydration = (
  persist: ZustandPersistApi | undefined,
  onHydrated: () => void,
): undefined | (() => void) => {
  if (!persist) {
    onHydrated();
    return;
  }

  if (persist.hasHydrated()) {
    onHydrated();
    return;
  }

  return persist.onFinishHydration(onHydrated);
};
